import { render, staticRenderFns } from "./FormHeadline.vue?vue&type=template&id=781bf220&"
import script from "./FormHeadline.vue?vue&type=script&lang=js&"
export * from "./FormHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports